export default {
  timeFormats: {
    DATE:"Dokładny zakres dat",
    TODAY: "Dzisiaj",
    YESTERDAY: "Wczoraj",
    LAST_7:"Ostatnie 7 dni",
    LAST_30:"Ostatnie 30 dni",
    THIS_MONTH:"Ten miesiąc",
    LAST_MONTH:"Ostatni miesiąc",
    THIS_YEAR:"Ten rok",
    LAST_YEAR:"Ostatni rok"
  },
  BF2:"BF2",
  BF3:"BF3",
  BF3_PLUS:"BF3+",
  BF4:"BF4",
  VLM:"VLM",
  KRS_CDiG:"CEIDG",
  FILE:"Plik"
};
